(function () {
    'use strict';

    function hasActiveProducts() {
        return function (items) {
            for (var i = 0; i < items.length; i++) {
                for (var j = 0; j < items[i].ProductDefinitions.length; j++) {
                    if (items[i].ProductDefinitions[j].isSelected) {
                        return true;
                    }
                }
            }
            return false;
        };
    }

    angular.module('ecap.workflow').filter('hasActiveProducts', hasActiveProducts);
})();
